(function () {
if (customElements.get('compare-manager')) return;

var STORAGE_KEY = 'teddy-compare';

class CompareManager extends HTMLElement {
  constructor() {
    super();
    this.items = [];
    this.columnCache = {};
    this._mq = window.matchMedia('(min-width: 1024px)');
  }

  connectedCallback() {
    this.currency = this.getAttribute('data-currency') || 'USD';
    this.API_BASE = this.getAttribute('data-api-base') || 'https://teddy-baldassarre.vercel.app';

    this.bar = document.querySelector('[data-compare-bar]');
    this.drawer = document.querySelector('[data-compare-drawer]');
    this.veil = document.querySelector('[data-compare-veil]');
    this.expanded = false;
    this.items = this._read();

    document.addEventListener('click', this.handleClick.bind(this));
    document.addEventListener('keydown', this.handleKeydown.bind(this));
    // PDP variant refresh replaces the add-to-cart block, and the compare
    // button lives inside it — re-render the fresh markup's state.
    document.addEventListener('pdp:refreshed', this.renderButtons.bind(this));

    var onBreakpoint = function () {
      this._enforceLimit();
      this.renderAll();
    }.bind(this);
    if (this._mq.addEventListener) {
      this._mq.addEventListener('change', onBreakpoint);
    } else {
      this._mq.addListener(onBreakpoint);
    }

    var resizeTimer = null;
    var lastDesktop = this._mq.matches;
    var self = this;
    window.addEventListener('resize', function () {
      if (self.expanded) self.bar.style.height = self._expandedHeight() + 'px';
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (self._mq.matches !== lastDesktop) {
          lastDesktop = self._mq.matches;
          onBreakpoint();
        }
      }, 200);
    }, { passive: true });

    if (window.ResizeObserver && this.bar) {
      this._barObserver = new ResizeObserver(function () {
        self._positionBanner();
      });
      this._barObserver.observe(this.bar);
    }

    this._observeInjectedCards();
    this._ensureChatStyleTag();
    this._enforceLimit();
    this.renderAll();
    this._syncOnReturn();
  }

  _syncOnReturn() {
    var self = this;
    var resync = function () {
      var fresh = self._read();
      if (JSON.stringify(fresh) === JSON.stringify(self.items)) return;
      self.items = fresh;
      self.columnCache = {};
      if (self.expanded) self.closeModal();
      self._enforceLimit();
      self.renderAll();
    };
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) resync();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') resync();
    });
    window.addEventListener('storage', function (e) {
      if (e.key === STORAGE_KEY || e.key === null) resync();
    });
  }

  maxItems() {
    return this._mq.matches ? 3 : 2;
  }

  isDesktop() {
    return this._mq.matches;
  }

  _read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var data = JSON.parse(raw);
      if (!data || !Array.isArray(data.items)) return [];
      return data.items.filter(function (i) { return i && i.id && i.handle; });
    } catch (e) {
      return [];
    }
  }

  _write() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ v: 1, items: this.items, updated: Date.now() }));
    } catch (e) {}
  }

  _enforceLimit() {
    var max = this.maxItems();
    if (this.items.length > max) {
      this.items = this.items.slice(0, max);
      this._write();
    }
  }

  has(id) {
    var pid = String(id);
    return this.items.some(function (i) { return String(i.id) === pid; });
  }

  _absoluteUrl(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    if (url.indexOf('/') === 0) return window.location.origin + url;
    return url;
  }

  _extractMeta(el) {
    return {
      id: el.getAttribute('data-compare-product-id'),
      handle: el.getAttribute('data-product-handle'),
      title: el.getAttribute('data-product-title') || '',
      vendor: el.getAttribute('data-product-vendor') || '',
      price: el.getAttribute('data-product-price') || '',
      url: el.getAttribute('data-product-url') || '',
      image: this._absoluteUrl(el.getAttribute('data-product-image') || ''),
      tags: el.getAttribute('data-product-tags') || '',
      sku: el.getAttribute('data-variant-sku') || '',
      source: el.getAttribute('data-source') || ''
    };
  }

  toggle(el) {
    var meta = this._extractMeta(el);
    if (!meta.id || !meta.handle) return;

    if (this.has(meta.id)) {
      this.remove(meta.id, el);
      return;
    }

    if (this.items.length >= this.maxItems()) {
      this.showBanner('You can only compare ' + this.maxItems() + ' watches');
      return;
    }

    this.items.push(meta);
    this._write();
    this.renderAll();
    this.trackCompareEvent('Added to Compare', meta);
  }

  remove(id, triggerEl) {
    var pid = String(id);
    var removed = this.items.filter(function (i) { return String(i.id) === pid; })[0];
    this.items = this.items.filter(function (i) { return String(i.id) !== pid; });
    this._write();
    this.renderAll();
    if (removed) this.trackCompareEvent('Removed from Compare', removed);
    if (this.items.length < 2 && this.expanded) {
      this.closeModal();
    }
  }

  clear() {
    this.items = [];
    this._write();
    if (this.expanded) this.closeModal();
    this.hideBanner();
    this.renderAll();
  }

  handleClick(e) {
    var toggle = e.target.closest('[data-compare-toggle]');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      this.toggle(toggle);
      return;
    }

    var remove = e.target.closest('[data-compare-remove]');
    if (remove) {
      var chip = remove.closest('[data-compare-chip]');
      if (chip) this.remove(chip.getAttribute('data-compare-product-id'), remove);
      return;
    }

    var clear = e.target.closest('[data-compare-clear]');
    if (clear) {
      this.clear();
      return;
    }

    var open = e.target.closest('[data-compare-open]');
    if (open) {
      this.openModal();
      return;
    }

    var close = e.target.closest('[data-compare-modal-close]');
    if (close) {
      this.closeModal();
      return;
    }

    if (this.expanded && this.veil && e.target === this.veil) {
      this.closeModal();
      return;
    }

    var trayToggle = e.target.closest('[data-compare-tray-toggle]');
    if (trayToggle) {
      this.toggleTray();
      return;
    }

    var sectionToggle = e.target.closest('[data-compare-section-toggle]');
    if (sectionToggle) {
      this.toggleSection(sectionToggle);
      return;
    }

    if (this.expanded && this.drawer.contains(e.target)) {
      var navCta = e.target.closest('[data-handle]');
      if (navCta) this.closeModal();
    }
  }

  handleKeydown(e) {
    if (e.key === 'Escape' && this.expanded) {
      this.closeModal();
    }
  }

  showBanner(message) {
    var banner = document.querySelector('[data-compare-banner]');
    if (!banner) return;
    banner.textContent = message;
    banner.classList.add('compare-banner--visible');
    this._positionBanner();

    var self = this;
    if (this._bannerTimer) clearTimeout(this._bannerTimer);
    this._bannerTimer = setTimeout(function () {
      self.hideBanner();
    }, 3000);
  }

  hideBanner() {
    var banner = document.querySelector('[data-compare-banner]');
    if (!banner) return;
    if (this._bannerTimer) {
      clearTimeout(this._bannerTimer);
      this._bannerTimer = null;
    }
    banner.classList.remove('compare-banner--visible');
    this._syncFixedBar();
  }

  _positionBanner() {
    var banner = document.querySelector('[data-compare-banner]');
    if (!banner || !this.bar) return;
    var anchored = this.items.length > 0 ? this.bar.offsetHeight || 0 : 0;
    banner.style.bottom = anchored + 'px';
    this._syncFixedBar();
  }

  _setChatBottom(px) {
    document.documentElement.style.setProperty('--fixedbar-chat-bottom', Math.max(0, px) + 'px');
  }

  renderAll() {
    this.renderButtons();
    this.renderBar();
    this._positionBanner();
  }

  renderButtons() {
    var buttons = document.querySelectorAll('[data-compare-toggle]');
    var full = this.items.length >= this.maxItems();
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var active = this.has(btn.getAttribute('data-compare-product-id'));
      var maxed = !active && full;
      btn.classList.toggle('compare-toggle--added', active);
      btn.classList.toggle('compare-toggle--max', maxed);
      var textEl = btn.querySelector('.compare-toggle__text');
      if (textEl) {
        textEl.textContent = active ? 'Added' : maxed ? 'Max reached' : 'Compare';
      }
      if (btn.closest('.product-item') && btn.parentElement) {
        btn.parentElement.classList.toggle('compare-frame--selected', active);
      }
    }
  }

  renderBar() {
    if (!this.bar) return;
    var count = this.items.length;
    var max = this.maxItems();

    this.bar.classList.toggle('compare-bar--active', count > 0);
    document.body.classList.toggle('compare-active', count > 0);

    var counts = this.bar.querySelectorAll('[data-compare-count]');
    for (var i = 0; i < counts.length; i++) counts[i].textContent = count;
    var maxEls = this.bar.querySelectorAll('[data-compare-max]');
    for (var j = 0; j < maxEls.length; j++) maxEls[j].textContent = max;

    var opens = this.bar.querySelectorAll('[data-compare-open]');
    for (var k = 0; k < opens.length; k++) opens[k].classList.toggle('hidden', count < 2);


    var slots = this.bar.querySelector('[data-compare-slots]');
    if (slots) {
      slots.textContent = '';
      for (var s = 0; s < max; s++) {
        if (this.items[s]) {
          slots.appendChild(this._buildChip(this.items[s], 'data-compare-chip-tpl'));
        } else {
          var slotTpl = document.querySelector('template[data-compare-slot-tpl]');
          if (slotTpl) slots.appendChild(slotTpl.content.cloneNode(true));
        }
      }
    }

    var trayItems = this.bar.querySelector('[data-compare-tray-items]');
    if (trayItems) {
      trayItems.textContent = '';
      for (var t = 0; t < max; t++) {
        if (this.items[t]) {
          trayItems.appendChild(this._buildChip(this.items[t], 'data-compare-chip-row-tpl'));
        } else {
          var rowSlotTpl = document.querySelector('template[data-compare-slot-row-tpl]');
          if (rowSlotTpl) trayItems.appendChild(rowSlotTpl.content.cloneNode(true));
        }
      }
    }

    if (count === 0) this._setTrayOpen(false);
  }

  _buildChip(item, tplAttr) {
    var tpl = document.querySelector('template[' + tplAttr + ']');
    var frag = tpl.content.cloneNode(true);
    var chip = frag.querySelector('[data-compare-chip]');
    chip.setAttribute('data-compare-product-id', item.id);
    var link = frag.querySelector('[data-chip-link]');
    if (link) link.href = item.url;
    var img = frag.querySelector('[data-chip-image]');
    if (img) {
      img.src = item.image;
      img.alt = item.title;
    }
    var vendor = frag.querySelector('[data-chip-vendor]');
    if (vendor) vendor.textContent = item.vendor;
    var title = frag.querySelector('[data-chip-title]');
    if (title) title.textContent = item.title;
    return frag;
  }

  toggleTray() {
    var tray = this.bar && this.bar.querySelector('[data-compare-tray]');
    if (!tray) return;
    this._setTrayOpen(tray.classList.contains('hidden'));
  }

  _setTrayOpen(open) {
    if (!this.bar) return;
    var tray = this.bar.querySelector('[data-compare-tray]');
    var caret = this.bar.querySelector('[data-compare-tray-caret]');
    if (tray) tray.classList.toggle('hidden', !open);
    if (caret) caret.style.transform = open ? 'rotate(180deg)' : '';
    this._positionBanner();
  }

  toggleSection(toggleEl) {
    var section = toggleEl.closest('[data-compare-section]');
    if (!section) return;
    var rows = section.querySelector('[data-compare-section-rows]');
    var caret = toggleEl.querySelector('[data-section-caret]');
    var isOpen = rows && !rows.classList.contains('hidden');
    if (rows) rows.classList.toggle('hidden', isOpen);
    if (caret) caret.style.transform = isOpen ? 'rotate(180deg)' : '';
    toggleEl.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
  }

  _fetchColumn(item) {
    var self = this;
    if (this.columnCache[item.handle]) return Promise.resolve(this.columnCache[item.handle]);
    var url = item.url.split('?')[0] + '?section_id=compare-column';
    return fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('Section fetch failed');
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var col = doc.querySelector('[data-compare-column]');
        if (col) self.columnCache[item.handle] = col;
        return col;
      })
      .catch(function () {
        return null;
      });
  }

  openModal() {
    if (!this.drawer || !this.bar || this.items.length < 2 || this.expanded) return;
    var self = this;
    var snapshot = this.items.slice();

    Promise.all(snapshot.map(this._fetchColumn.bind(this))).then(function (cols) {
      var pairs = [];
      for (var i = 0; i < snapshot.length; i++) {
        if (cols[i]) pairs.push({ item: snapshot[i], col: cols[i] });
      }
      if (pairs.length < 2) {
        self.showBanner('Unable to load comparison right now');
        return;
      }
      self._buildModal(pairs);
      self._setTrayOpen(false);
      self._expand();
      self.trackViewedComparison(pairs);
    });
  }

  _expandedHeight() {
    return Math.max(320, window.innerHeight - 80);
  }

  _expand() {
    var bar = this.bar;
    this._collapsedHeight = bar.offsetHeight;
    bar.style.height = this._collapsedHeight + 'px';
    void bar.offsetHeight;

    this.expanded = true;
    bar.classList.add('compare-bar--elevated');
    bar.classList.add('compare-bar--expanded');
    document.body.classList.add('compare-drawer-open');
    if (this.veil) {
      this.veil.classList.add('compare-veil--elevated');
      this.veil.classList.add('compare-veil--visible');
    }
    document.body.style.overflow = 'hidden';
    bar.style.height = this._expandedHeight() + 'px';
  }

  closeModal() {
    if (!this.bar || !this.expanded) return;
    var bar = this.bar;
    var self = this;

    bar.style.height = bar.offsetHeight + 'px';
    void bar.offsetHeight;

    this.expanded = false;
    bar.classList.remove('compare-bar--expanded');
    document.body.classList.remove('compare-drawer-open');
    if (this.veil) this.veil.classList.remove('compare-veil--visible');
    document.body.style.overflow = '';
    bar.style.height = (this._collapsedHeight || 0) + 'px';

    var done = function (e) {
      if (e && e.propertyName !== 'height') return;
      bar.removeEventListener('transitionend', done);
      if (self._collapseTimer) {
        clearTimeout(self._collapseTimer);
        self._collapseTimer = null;
      }
      if (self.expanded) return;
      bar.style.height = '';
      bar.classList.remove('compare-bar--elevated');
      if (self.veil) self.veil.classList.remove('compare-veil--elevated');
      var scroll = self.drawer && self.drawer.querySelector('[data-compare-scroll]');
      if (scroll) scroll.scrollTop = 0;
      self._positionBanner();
    };
    bar.addEventListener('transitionend', done);
    if (this._collapseTimer) clearTimeout(this._collapseTimer);
    this._collapseTimer = setTimeout(function () { done(); }, 700);

    var stickyWrap = this.drawer && this.drawer.querySelector('[data-compare-sticky]');
    if (stickyWrap) stickyWrap.classList.remove('compare-sticky--visible');
  }

  _buildModal(pairs) {
    var grid = this.drawer.querySelector('[data-compare-grid]');
    var headers = this.drawer.querySelector('[data-compare-headers]');
    var sectionsWrap = this.drawer.querySelector('[data-compare-sections]');
    var stickyWrap = this.drawer.querySelector('[data-compare-sticky]');
    var stickyRow = this.drawer.querySelector('[data-compare-sticky-row]');
    if (!grid || !headers || !sectionsWrap) return;

    var cols = Math.max(pairs.length, this.maxItems());
    grid.style.setProperty('--compare-cols', cols);
    if (stickyWrap) stickyWrap.style.setProperty('--compare-cols', cols);

    headers.textContent = '';
    var headerSpacer = document.createElement('div');
    headerSpacer.className = 'compare-row__label';
    headers.appendChild(headerSpacer);
    pairs.forEach(function (pair) {
      var header = pair.col.querySelector('[data-compare-col-header]');
      headers.appendChild(header ? header.cloneNode(true) : document.createElement('div'));
    });

    if (stickyRow) {
      stickyRow.textContent = '';
      var stickySpacer = document.createElement('div');
      stickySpacer.className = 'compare-row__label';
      stickyRow.appendChild(stickySpacer);
      var stickyTpl = document.querySelector('template[data-compare-sticky-col-tpl]');
      pairs.forEach(function (pair) {
        var frag = stickyTpl.content.cloneNode(true);
        var link = frag.querySelector('[data-sticky-link]');
        if (link) link.href = pair.item.url;
        var img = frag.querySelector('[data-sticky-image]');
        if (img) {
          img.src = pair.item.image;
          img.alt = pair.item.title;
        }
        var vendor = frag.querySelector('[data-sticky-vendor]');
        if (vendor) vendor.textContent = pair.item.vendor;
        var title = frag.querySelector('[data-sticky-title]');
        if (title) title.textContent = pair.item.title;
        stickyRow.appendChild(frag);
      });
    }

    var config = this._config();
    sectionsWrap.textContent = '';
    var sectionTpl = document.querySelector('template[data-compare-section-tpl]');
    var rowTpl = document.querySelector('template[data-compare-row-tpl]');
    var cellTpl = document.querySelector('template[data-compare-cell-tpl]');
    var reviewTpl = document.querySelector('template[data-compare-review-tpl]');
    var self = this;

    config.sections.forEach(function (sectionCfg) {
      var sectionFrag = sectionTpl.content.cloneNode(true);
      var titleEl = sectionFrag.querySelector('[data-section-title]');
      if (titleEl) titleEl.textContent = sectionCfg.title;
      var rowsWrap = sectionFrag.querySelector('[data-compare-section-rows]');

      var rowCount = 0;
      sectionCfg.rows.forEach(function (rowCfg) {
        var rowFrag = rowTpl.content.cloneNode(true);
        var row = rowFrag.firstElementChild;
        var label = rowFrag.querySelector('[data-row-label]');
        if (label) label.textContent = rowCfg.label;

        var hasValue = false;
        pairs.forEach(function (pair) {
          var cellFrag = cellTpl.content.cloneNode(true);
          var cell = cellFrag.firstElementChild;
          if (self._fillCell(cell, rowCfg, pair, reviewTpl)) hasValue = true;
          row.appendChild(cell);
        });

        if (!hasValue) return;
        rowsWrap.appendChild(rowFrag);
        rowCount++;
      });

      if (rowCount) sectionsWrap.appendChild(sectionFrag);
    });

    this._setupStickyHeader(headers, stickyWrap);
  }

  _fillCell(cell, rowCfg, pair, reviewTpl) {
    if (rowCfg.type === 'review') {
      var videoId = pair.col.getAttribute('data-video-id');
      if (videoId && reviewTpl) {
        var frag = reviewTpl.content.cloneNode(true);
        var btn = frag.querySelector('button');
        btn.setAttribute('data-video-id', videoId);
        btn.setAttribute('data-product-url', pair.item.url);
        btn.setAttribute('data-product-vendor', pair.item.vendor);
        btn.setAttribute('data-product-title', pair.item.title);
        btn.setAttribute('data-product-image', pair.item.image);
        cell.appendChild(frag);
        var ctaTpl = pair.col.querySelector('template[data-compare-cta-tpl]');
        if (ctaTpl) cell.appendChild(ctaTpl.cloneNode(true));
        return true;
      }
      cell.textContent = '–';
      return false;
    }

    var value = '';
    if (rowCfg.type === 'price') {
      value = pair.col.getAttribute('data-price-formatted') || '';
    } else {
      var specs = pair.col.querySelector('[data-compare-specs]');
      if (specs && rowCfg.chain) {
        for (var i = 0; i < rowCfg.chain.length; i++) {
          var attr = specs.getAttribute('data-mf-' + rowCfg.chain[i]);
          if (attr) {
            value = attr;
            break;
          }
        }
      }
    }

    if (this._isEmptyValue(value)) {
      cell.textContent = '–';
      return false;
    }
    cell.textContent = value;
    return true;
  }

  _isEmptyValue(value) {
    var v = String(value || '').trim().toLowerCase();
    return !v || v === 'n/a' || v === 'na' || v === '-' || v === '–' || v === '—';
  }

  _config() {
    if (this._configCache) return this._configCache;
    var el = document.querySelector('script[data-compare-config]');
    try {
      this._configCache = JSON.parse(el.textContent);
    } catch (e) {
      this._configCache = { sections: [] };
    }
    return this._configCache;
  }

  _setupStickyHeader(headers, stickyWrap) {
    if (!stickyWrap) return;
    var scroll = this.drawer.querySelector('[data-compare-scroll]');
    if (!scroll) return;

    if (this._stickyScrollHandler) {
      scroll.removeEventListener('scroll', this._stickyScrollHandler);
    }

    var update = function () {
      var past = scroll.scrollTop >= headers.offsetHeight - 8;
      stickyWrap.classList.toggle('compare-sticky--visible', past);
    };

    this._stickyScrollHandler = update;
    scroll.addEventListener('scroll', update, { passive: true });
    update();
  }

  _observeInjectedCards() {
    var self = this;
    var pending = null;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = requestAnimationFrame(function () {
        pending = null;
        self.renderButtons();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  _ensureChatStyleTag() {
    if (document.getElementById('fixedbar-chat-style')) return;
    if (document.getElementById('compare-chat-style')) return;
    var style = document.createElement('style');
    style.id = 'compare-chat-style';
    style.textContent = ':root{ --fixedbar-chat-bottom: 0px; } #chat-widget-container{ bottom: var(--fixedbar-chat-bottom) !important; transition: bottom 0.3s ease !important; }';
    document.head.appendChild(style);
  }

  _syncFixedBar() {
    if (!this.bar || this.expanded) return;
    var banner = document.querySelector('[data-compare-banner]');
    var bannerLift = banner && banner.classList.contains('compare-banner--visible')
      ? banner.offsetHeight
      : 0;
    var fixedBar = document.querySelector('fixed-bar');
    if (fixedBar && typeof fixedBar._update === 'function') {
      fixedBar._update();
    }

    if (this.items.length > 0) {
      this._setChatBottom((this.bar.offsetHeight || 0) + bannerLift);
    } else if (!fixedBar) {
      this._setChatBottom(bannerLift);
    }
  }

  trackCompareEvent(eventName, meta) {
    if (!window.klaviyo || typeof window.klaviyo.track !== 'function') return;
    var market = window.__teddy || {};
    window.klaviyo.track(eventName, {
      ProductName: meta.title,
      ProductID: meta.id,
      Brand: meta.vendor,
      Price: meta.price ? parseFloat(meta.price) / 100 : null,
      Currency: this.currency,
      ProductURL: window.location.origin + meta.url,
      ImageURL: meta.image,
      ProductCategories: (meta.tags || '').split(',').filter(Boolean),
      SKU: meta.sku || null,
      Source: meta.source || null,
      CompareCount: this.items.length,
      unique_id: crypto.randomUUID(),
      Market: market.marketName || ''
    });
  }

  trackViewedComparison(pairs) {
    var market = window.__teddy || {};
    var self = this;
    var products = pairs.map(function (pair) {
      return {
        ProductID: pair.item.id,
        ProductName: pair.item.title,
        Brand: pair.item.vendor,
        SKU: pair.item.sku || null,
        Price: pair.item.price ? parseFloat(pair.item.price) / 100 : null,
        ProductURL: window.location.origin + pair.item.url
      };
    });

    if (window.klaviyo && typeof window.klaviyo.track === 'function') {
      window.klaviyo.track('Viewed Comparison', {
        ComparedProducts: products,
        CompareCount: products.length,
        Currency: this.currency,
        unique_id: crypto.randomUUID(),
        Market: market.marketName || ''
      });
    }

    var email = market.customerEmail;
    if (email) {
      fetch(this.API_BASE + '/api/hubspot-track-compare', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({
          email: email,
          pageUrl: window.location.href,
          products: products.map(function (p) {
            return { sku: p.SKU, title: p.ProductName, vendor: p.Brand, price: p.Price };
          })
        })
      }).catch(function () {});
    }
  }
}

customElements.define('compare-manager', CompareManager);
})();
